import APIClient from '@/shared/http/clients/api'

const resourceName = 'regulationautoanalyze'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}`, data, config)
const GetAllPaging = (regulationAutoID, limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/GetAll/${regulationAutoID}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/${id}`, config)
const GetByRegulationAutoID = (id, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationauto/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIRegAuto}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIRegAuto}/${resourceName}/${id}`, config)

const RegulationAutoAnalyze = {
  GetAll,
  GetAllPaging,
  GetById,
  GetByRegulationAutoID,
  Create,
  Update,
  Delete
}

export default RegulationAutoAnalyze



// WEBPACK FOOTER //
// ./src/shared/http/repositories/regulation/auto/regulationautoanalyze.js